import React from 'react';
import { AlertTriangle, RefreshCcw, Home } from 'lucide-react';

interface ErrorFallbackProps {
  error?: Error;
  resetErrorBoundary?: () => void;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 text-slate-900 p-6">
      <div className="w-full max-w-md bg-white rounded-xl shadow-xl border border-slate-200 overflow-hidden">
        <div className="bg-red-50 p-6 flex flex-col items-center text-center border-b border-red-100">
          <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle size={24} />
          </div>
          <h2 className="text-xl font-bold text-red-900 mb-1">Application Error</h2>
          <p className="text-sm text-red-600">Something went wrong while rendering this component.</p>
        </div>
        
        <div className="p-6 space-y-4">
          <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
             <p className="text-xs font-mono text-slate-600 break-words">
                {error?.message || "Unknown error occurred"}
             </p>
          </div>

          <div className="flex flex-col gap-2">
            <button 
              onClick={resetErrorBoundary || (() => window.location.reload())}
              className="w-full py-2.5 bg-teal-600 hover:bg-teal-700 text-white rounded-lg font-bold flex items-center justify-center gap-2 transition-colors shadow-sm"
            >
              <RefreshCcw size={16} /> Try Again
            </button>
            <button 
              onClick={() => window.location.href = '/'}
              className="w-full py-2.5 bg-white border border-slate-200 hover:bg-slate-50 text-slate-600 rounded-lg font-bold flex items-center justify-center gap-2 transition-colors"
            >
              <Home size={16} /> Return Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};